const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const EVM_RE = /^0x[0-9a-fA-F]{40}$/;

/**
 * One entry per line (commas / spaces also split). UUIDs → userIds, EVM wallets
 * (0x + 40 hex) → walletAddresses, anything else → invalid. Case-insensitive dedupe.
 */
export function parseReclaimEntries(text: string): {
  userIds: string[];
  walletAddresses: string[];
  invalid: string[];
} {
  const userIds: string[] = [];
  const walletAddresses: string[] = [];
  const invalid: string[] = [];
  const seen = new Set<string>();
  text
    .split(/[\s,]+/)
    .map((s) => s.trim())
    .filter(Boolean)
    .forEach((s) => {
      const key = s.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      if (UUID_RE.test(s)) userIds.push(s);
      else if (EVM_RE.test(s)) walletAddresses.push(s);
      else invalid.push(s);
    });
  return { userIds, walletAddresses, invalid };
}
